import React from "react";
import * as Icon from "react-feather";

import JaneReportService from "../../../../services/JaneReportService";

import WComponent from "../../../common/WComponent";
import Loader from "../../../common/loader/Loader";

import ToolsCollapsiblePanel from "../kit/ToolsCollapsiblePanel";

import "./departures-panel.css";

class DeparturesPanel extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			hasLoaded: false,
			isLoading: false,
			comparedWith: null,
			journalsRead: 0,
			departures: [],
			errorMessage: ""
		};
	}

	onOpened = async () => {
		const { hasLoaded, isLoading } = this.state;

		if (hasLoaded || isLoading) {
			return;
		}

		const { clientId, built, periodEnd } = this.props;

		await this.update({ isLoading: true, errorMessage: "" });
		const result = await JaneReportService.compareWithPreviousJournal({ clientId, built, periodEnd });

		if (result.error) {
			await this.update({ isLoading: false, hasLoaded: true, errorMessage: result.error });
			return;
		}

		await this.update({
			isLoading: false,
			hasLoaded: true,
			comparedWith: result.comparedWith,
			journalsRead: result.journalsRead || 0,
			departures: result.departures
		});
	};

	renderDeparture = ({ departure }) => {
		return (
			<div className="tk-stacked" key={departure.key}>
				<div className="departures__title">{departure.title}</div>

				<div className="departures__sides">
					<div className="departures__side">
						<div className="departures__side-label tk-section-label">Your last journal</div>
						<div className="departures__side-text">{departure.theirs}</div>
					</div>
					<div className="departures__side">
						<div className="departures__side-label tk-section-label">This one</div>
						<div className="departures__side-text departures__side-text--ours">{departure.ours}</div>
					</div>
				</div>

				<div className="departures__why tk-text-muted">{departure.why}</div>
			</div>
		);
	};

	renderBody() {
		const { isLoading, hasLoaded, comparedWith, journalsRead, departures, errorMessage } = this.state;

		if (isLoading) {
			return (
				<div className="tk-panel-loading">
					<Loader />
					<span className="tk-text-muted">Reading the last journal this client posted…</span>
				</div>
			);
		}

		if (errorMessage) {
			return <div className="departures__error tk-text-muted">{errorMessage}</div>;
		}

		if (!hasLoaded) {
			return null;
		}

		if (!comparedWith) {
			return (
				<div className="departures__none tk-text-muted">
					This client has no previous Jane journal to compare against, so there is nothing this entry departs from.
				</div>
			);
		}

		return (
			<>
				<div className="departures__source tk-text-muted">
					Compared against {comparedWith.docNumber || "the entry"} posted {comparedWith.date}, {comparedWith.lineCount} lines, read together with{" "}
					{journalsRead} of this client's previous journals.
				</div>

				{departures.length === 0 ? (
					<div className="departures__none tk-text-muted">
						Nothing differs in shape. This entry records the same things in the same places as the last one.
					</div>
				) : (
					<div>{departures.map(departure => this.renderDeparture({ departure }))}</div>
				)}
			</>
		);
	}

	render() {
		const { departures, hasLoaded } = this.state;

		const status = hasLoaded ? (
			departures.length === 0 ? (
				<span className="tk-badge tk-badge--success">Nothing differs</span>
			) : (
				<span className="tk-badge tk-badge--warning">
					{departures.length} {departures.length === 1 ? "difference" : "differences"}
				</span>
			)
		) : (
			<span className="tk-text-muted departures__prompt">
				<Icon.Search size={13} /> Click to compare
			</span>
		);

		return (
			<ToolsCollapsiblePanel title="How this differs from your last journal" defaultOpen={false} onOpen={this.onOpened} status={status}>
				{this.renderBody()}
			</ToolsCollapsiblePanel>
		);
	}
}

export default DeparturesPanel;
